import { render, staticRenderFns } from "./StaffTable.vue?vue&type=template&id=d8ef5f84&"
import script from "./StaffTable.vue?vue&type=script&lang=js&"
export * from "./StaffTable.vue?vue&type=script&lang=js&"
import style0 from "./StaffTable.vue?vue&type=style&index=0&id=d8ef5f84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports